import HeadNav from "../../components/HeadNav";
import {cutPhone, cutPhone1, showTotalData, fmDate,fmDate1, encrypt, LZStringCompress} from "../../tools";
import {
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub,
  substringStr,
  substringStr1,
  noRepeat
} from "../../tools/indexFun";
import {Toast} from 'vant';
import ListEmpty from "../../components/ListEmpty";
import {
  withdrawTotalDistributionIncome,
  getCommissionRelationshipChildren,
  getDepositLog,
  setUnit1,
  userTotalDistributionIncome,
  userTotalDistributionIncomeCanWithdraw,
  userTotalDistributionIncomeCanWithdrawOut,
  userTotalDistributionIncomeOut,
  powerUserTotalDistributionIncomeCanWithdraw,
  powerWithdrawTotalDistributionIncome,
  getCFCCurrentPrice,
  getUserLevelInfo,
  getDepositLogB,
  getDayNumber,
  getSingleDayIncome,
  userPoolInfo,
  getuAmountFromPoolMappingTimeStart,
  getReleaseUser, getuserTotalDistributionIncomeCanWithdraw,
} from "../../tools/chain";
import Clipboard from "clipboard";
import {contractAddress} from "../../config";
let bCure = false;
export default {
  name: "inviteFriends",
  components: {
    HeadNav,
    ListEmpty
  },
  data() {
    return {
      active: 0,
      showShare: false,
      show: false,
      tabIndex: '',
      money: 0,
      CFCCurrentPrice: 0,
      exchange: 0,
      userTotalDistributionIncome: 0,
      userTotalDistributionIncomeCanWithdraw: 0,
      userTotalDistributionIncomeCanWithdrawOut: 0,
      userTotalDistributionIncomeOut: 0,
      cfcBalance: 0,
      iPowerUserTotalDistributionIncomeCanWithdraw: 0,
      userLevelInfo:[],
      options: [
        {name: '复制链接', icon: 'link'},
      ],
      commissionRelationshipChildren: [],
      depositLog: [],
      depositLog1: [],
    }

  },
  created() {
  },
  methods: {
    BigNumberStr(num1,num2,col){
      return BigNumberStr(num1,num2,col);
    },
    BigNumberDiv(num1,num2,col){
      return BigNumberDiv(num1,num2,col);
    },
    BigNumberSub(num1,num2,col){
      return BigNumberSub(num1,num2,col);
    },
    substringStr(str = "", chars = 3){
      return substringStr(str, chars)
    },
    substringStr1(str = "", chars = 10){
      return substringStr1(str, chars)
    },
    //获取团队交易总金额
    async getUserLevelInfo(){
      this.userLevelInfo = await getUserLevelInfo(this.$store.state.accounts[0]);
    },
    showToast(){
      Toast.fail({
        message:this.langUtil(89)
      })
    },
    goToReferralIncome(){
      this.tabIndex=1
      this.$router.push(`/ReferralIncome/${this.tabIndex}`)
    },
    showTotalData(data) {
      return showTotalData(data)
    },
    onSelect() {
      this.showShare = false;
    },
    goToWI() {
      this.tabIndex = 0
      setTimeout(() => {
        this.$router.push('/WithdrawIncome')
      }, 200);
      this.show = false;
    },
    goToWI2() {
      this.tabIndex = 1
      setTimeout(() => {
        this.$router.push(`/withdrawCFC/${this.tabIndex}`)
      }, 200);
      // this.show = false;
      // Toast.fail(this.langUtil(80))
    },
    async getCommissionRelationshipChildren() {
      this.commissionRelationshipChildren = await this.getChildern(this.$store.state.accounts[0])
    },
    async getChildern(address_) {
      let arr = [];
      const loop = async (address_) => {
        let commissionRelationshipChildren = await getCommissionRelationshipChildren(1, 200, address_);
        arr = await noRepeat(commissionRelationshipChildren);
        // console.log('arr',address_,arr);
        // if (arr.length <= 10){
        //   for (let k in commissionRelationshipChildren) {
        //     await loop(commissionRelationshipChildren[k])
        //   }
        // }
      }
      await loop(address_)
      return arr;
    },
    async getDepositLog() {
      this.depositLog = await getDepositLog(1, 200, this.$store.state.accounts[0]);
      // console.log('111',this.depositLog)
    },
    async getDepositLogB() {
      let depositTime = await getuAmountFromPoolMappingTimeStart(this.$store.state.accounts[0]);
      let uDay = await getDayNumber(depositTime, Date.now());
      let getSingleDayIncome1 = await getReleaseUser(this.$store.state.accounts[0]);
      getSingleDayIncome1 = BigNumberStr(getSingleDayIncome1[1],18,3)
      let funds = await getuserTotalDistributionIncomeCanWithdraw(this.$store.state.accounts[0]);
      for (let i = 1; i <= uDay; i++) {
        let obj = {
          time: depositTime * 1 + i * 60 * 60 * 24,
          depositNumber: funds,
          income: getSingleDayIncome1
        }
        this.depositLog1.push(obj)
      }
    },
    async getUserTotalDistributionIncome() {
      this.userTotalDistributionIncome = await userTotalDistributionIncome(this.$store.state.accounts[0]);
    },
    async getUserTotalDistributionIncomeCanWithdraw() {
      this.userTotalDistributionIncomeCanWithdraw = await userTotalDistributionIncomeCanWithdraw(this.$store.state.accounts[0]);
    },
    async getUserTotalDistributionIncomeCanWithdrawOut() {
      this.userTotalDistributionIncomeCanWithdrawOut = await userTotalDistributionIncomeCanWithdrawOut(this.$store.state.accounts[0]);
    },
    async getuserTotalDistributionIncomeOut() {
      this.userTotalDistributionIncomeOut = await userTotalDistributionIncomeOut(this.$store.state.accounts[0]);
    },
    async powerUserTotalDistributionIncomeCanWithdraw() {
      this.iPowerUserTotalDistributionIncomeCanWithdraw = await powerUserTotalDistributionIncomeCanWithdraw(this.$store.state.accounts[0]);
    },
    refresh() {
      this.getCommissionRelationshipChildren();
      this.getDepositLog();
      this.getDepositLogB();
      this.getUserTotalDistributionIncome();
      this.getUserTotalDistributionIncomeCanWithdraw();
      this.getUserTotalDistributionIncomeCanWithdrawOut();
      this.getuserTotalDistributionIncomeOut();
      this.powerUserTotalDistributionIncomeCanWithdraw();
      this.getCFCCurrentPrice();
      this.getUserLevelInfo()
    },
    cutPhone(phone) {
      return cutPhone(phone);
    },
    cutPhone1(phone) {
      return cutPhone1(phone);
    },
    setUnit1(phone) {
      return setUnit1(phone);
    },
    fmDate(phone) {
      return fmDate(phone);
    },
    fmDate1(phone) {
      return fmDate1(phone);
    },
    clickShowShare(){
      if (this.$store.state.accounts.length === 0) return;
      this.showShare=true;
      setTimeout(async () => {
        await document.querySelector(".van-share-sheet__option").setAttribute('data-clipboard-text', `${window.location.origin}?pass=${LZStringCompress(this.$store.state.accounts[0])}`)
        const clipboard = new Clipboard(".van-share-sheet__option");
        clipboard.on('success',  (e) => {
          e.clearSelection();
          Toast.success({
            message: this.langUtil(42),
          });
        });
      }, 500)
    },
    //提取推荐人usdt
    async onsubmit() {
      if (this.userTotalDistributionIncomeCanWithdraw == 0){
        Toast.fail({
          message: this.langUtil(80)
        })
        return;
      }
      await withdrawTotalDistributionIncome();
      this.refresh();
      this.show = false;
      Toast.success({
        message: this.langUtil(72)
      })
    },
    //提取cfc
    async onsubmit2() {
      if (this.iPowerUserTotalDistributionIncomeCanWithdraw==0){
        Toast({
          type:"fail",
          message:this.langUtil(80)
        });
        this.show=false
      }else {
      try {
        if (bCure) return;
        bCure = true;
        Toast({
          type: "loading",
          duration: 0,
        });
        await powerWithdrawTotalDistributionIncome();
        Toast.clear();
        this.refresh();
        Toast.success({
          message: this.langUtil(72),
          onClose: () => {
          }
        })
      }catch (e){
        bCure = false;
        Toast.clear();
        Toast({
          type: "fail",
          message: "sorry, the transaction is fail:" + e.message || e.toString(),
        });
      }}

    },
    async getCFCCurrentPrice() {
      this.CFCCurrentPrice = await getCFCCurrentPrice(contractAddress.CFCToken, this.$store.state.accounts[0]);
    },
  },
  mounted() {
    this.refresh();
  }
}
